export default "__VITE_ASSET__CuLR7E5u__"